/* eslint semi: 1 */
import { hasPermissionToCreate, hasPermissionToAccess } from './permissions-common';

import _ from 'lodash';

/**
 * Videowall Page accessability is identical to LED Page except from this condition:
 * - The page is inaccessible if the user does not have at least one videowall tag
 */
export const hasAccessToVideowallPage = (currentUser, videowallTags) => {
  // it is always invisible when:
  // 1. There are no canvas/videowall tags
  // 2. It's a Dicovery account
  if (_.isEmpty(videowallTags) || _.isEmpty(currentUser) || currentUser.isFreeUser()) {
    return false;
  }

  // This should work differently for Enterprise and Premium
  if (currentUser.isEnterpriseUser()) {
    return hasPermissionToAccess(currentUser, videowallTags);
  }

  // there is no tags functionality available for the Premium accounts
  return hasPermissionToAccess(currentUser, []);
};

/**
 * Permission to create Videowall Project
 */
export const hasPermissionToCreateVideowallProject = (currentUser) => {
  if (_.isEmpty(currentUser) || currentUser.isFreeUser()) {
    return false;
  }
  return hasPermissionToCreate(currentUser);
};
